import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "science_body"
};
const _hoisted_2 = {
  class: "science_body_nr"
};
const _hoisted_3 = {
  class: "science_body_tab"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  key: 0,
  class: "science_body_nr_r"
};
const _hoisted_6 = {
  class: "science_body_nr_r_t"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "ne_data"
};
const _hoisted_9 = {
  class: "science_body_nr_r_b"
};
const _hoisted_10 = {
  class: "science_body_nr_r_b_list"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  class: "ne_data"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[3] || (_cache[3] = _createElementVNode("div", {
    class: "navbat"
  }, [_createElementVNode("span", null, "口腔知识")], -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tabList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      style: _normalizeStyle('color:' + ($setup.tabIndex == index ? '#fff;' : '#000;') + 'background:' + ($setup.tabIndex == index ? '#41B9B2;' : 'none;')),
      onClick: $event => $setup.tabClick(index)
    }, [_createElementVNode("span", null, _toDisplayString(item.name), 1)], 12, _hoisted_4);
  }), 128))]), $setup.get_data.top ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
    src: $setup.get_data.top[0].imgUrl,
    style: {
      "width": "675px",
      "height": "395px",
      "object-fit": "cover"
    }
  }, null, 8, _hoisted_7), _createElementVNode("span", _hoisted_8, _toDisplayString($setup.get_data.top[0].brief), 1)]), _createElementVNode("div", _hoisted_9, [_cache[2] || (_cache[2] = _createElementVNode("h1", null, "常见问题", -1)), _createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.get_data.top.length - 1, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      onClick: $event => $setup.details($setup.get_data.top[index + 1].id, index)
    }, [_createElementVNode("div", null, [_cache[0] || (_cache[0] = _createElementVNode("div", null, " 问 ", -1)), _createElementVNode("span", null, _toDisplayString($setup.get_data.top[index + 1].title), 1)]), _createElementVNode("div", _hoisted_12, _toDisplayString($setup.get_data.top[index + 1].brief), 1), _cache[1] || (_cache[1] = _createElementVNode("span", {
      class: "wzwd"
    }, "完整问答>", -1))], 8, _hoisted_11);
  }), 128))])])])) : _createCommentVNode("", true)])]);
}